export default "__VITE_ASSET__CgSh8Ps0__"